const consts = {
  MainUrl: "https://ez5050.com/",
  BackendUrl: "https://api.binary.hashcodexperts.com/brokerageApi",
  socketUrl: "https://api.binary.hashcodexperts.com/",
  type: "Production",

  apikey: "8ac6594932c84017812076c76ee107e9",
  twelvedataApi: "0211d3c26f6a486ab4d09b5b030065b9",


  // Main: "Development",
  // socketUrl: "http://localhost:3500",
  // MainUrl: "http://localhost:3000",
  // BackendUrl: "http://localhost:3500/brokerageApi",
  // PrimaryColor: "#F27303",
};

export default consts;
